import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const benefitsData = [
  {
    image:
      "https://sinch.com/wp-content/uploads/2024/08/WhatsApp-Business-Messaging-Engage-Customers-Hero.png",
    title: "Scan Securely on WhatsApp!",
    description:
      "Capture website visitors with a click-to-chat option on ads or website chat widget, instantly turning them into leads.",
  },
  {
    image:
      "https://www.interakt.shop/wp-content/uploads/2024/09/Integrate-WhatsApp-With-Your-Website-1.png",
    title: "Always just a click away",
    description:
      "Offer real-time, personalized support on WhatsApp, leading to happier customers.",
  },
  {
    image:
      "https://myoperator.com/blog/wp-content/uploads/2023/07/How-to-Use-Whatsapp-for-Customer-Service-V1-1.png",
    title: "Get leads Quickly with just a scan",
    description:
      "Generate a clickable link for website visitors & social media to chat directly on WhatsApp.",
  },
];

const Benefits = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      backgroundImage: `url('bg3.svg')`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
    }}
  >
    <Box
      sx={{
        width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        py: { xs: 5, md: 10 },
        px: { xs: 2, md: 8 },
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          marginBottom: "3rem",
          fontWeight: 600,
          fontSize: { xs: "2rem", md: "3rem" },
          color: "rgb(255,255,255)",
        }}
      >
        Get the WhatsApp QR Code Generator Free -{" "}
        <span style={{ color: "rgb(0, 209, 132)" }}>
          Benefits you can’t ignore!
        </span>
      </Typography>
      <Grid container spacing={4} justifyContent={'center'}>
        {benefitsData.map((benefit, idx) => (
          <Grid item xs={12} md={4} key={idx} 
          sx={{
            mb: '2rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          >
            <Box
              sx={{
                border: "1px solid #eee",
                borderRadius: "8px",
                padding: "1rem",
                textAlign: "left",
                background: "#fafafa",
                height: "100%",
                width: '100%',
              }}
            >
              <Box
                sx={{
                  height: { xs: "25vh" },
                  width: "100%",
                }}
              >
                <img
                  src={benefit.image}
                  alt={benefit.title}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </Box>

              <Typography
                sx={{
                  fontSize: "1.25rem",
                  margin: "0.5rem 0",
                  fontWeight: 600,
                }}
              >
                {benefit.title}
              </Typography>
              <Typography sx={{ color: "text.secondary", fontSize: "17px" }}>
                {benefit.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default Benefits;
